/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, {useContext, useRef, useState} from 'react'
import ImageSizeTooltip from './imageSizeTooltip'
import { CDN } from '../../config';
import { Storage } from 'aws-amplify';
import UploadProgress from '../UploadProgress';

const ProfileImageUpload = ({
    studentDetails,
    setStudentDetails,
    imageid,
    setToastErrorMessage,
    edit,

}) => {
    const [isHighlight, setIsHighlight] = useState(false);
    const [uploadLoading, setuploadLoading] = useState(false)
    const inputRef = useRef(null);
    const imageRef = useRef(null);

    const [imageSizeInfoHover, setImageSizeInfoHover] = useState(false)
    const handleImageToggle = () => {
        // Use the functional form of setState
        setImageSizeInfoHover((prevIsToggled) => !prevIsToggled);
    };
    async function handleUploadChange(e) {
        setuploadLoading(true)
        const Idealheight=600;
        const Idealwidth=600;
        let width='';
        let height=''        
        setIsHighlight(false)

        setToastErrorMessage("")
        const fileUpload = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(fileUpload);
    
        const readerPromise = new Promise((resolve, reject) => {
            reader.onload = () => {
                const img = new Image();
                img.src = reader.result;
                img.onload = () => {
                    resolve({ width: img.naturalWidth, height: img.naturalHeight });
                };
            };
            reader.onerror = reject;
        });

        try {
            const { width, height } = await readerPromise;    
            if (Idealwidth !== width || Idealheight !== height) {
                inputRef.current.value = "";
                setToastErrorMessage("Failed to upload. Incorrect pixel size, please use [600*600px].");
                setIsHighlight(true);
                setuploadLoading(false)
                return;
            }
    
            if (fileUpload.size > 5 * 1024 * 1024) {
                inputRef.current.value = "";
                setToastErrorMessage("Failed to upload image. File is exceeding the file size of 5MB");
                setIsHighlight(true);
                setuploadLoading(false)
            } else {
                const result = await Storage.put(`students/web/${fileUpload.name}`, fileUpload, {
                    contentType: fileUpload.type,
                    acl: "public-read",
                });
    
                setStudentDetails((prev) => ({
                    ...prev,
                    [imageid]: result.key,
                }));
                setuploadLoading(false)
            }
        } catch (error) {
            console.error("Error reading or processing image:", error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            setuploadLoading(false)
        }
    }


    const handleRemove =(key)=>{
        setStudentDetails((prv)=>({
            ...prv,
            [imageid]:''
        }))
    }


    return (
        <div>
            <div class="flex mb-4">
                <div class="relative w-fit">
                    <div class={`w-[96px] h-[96px] ${studentDetails[imageid] !== "" ? '' : 'border-dashed border-[2.5px]' }  ${isHighlight ? "border-[#F04438]" : "border-[#B3BBC1]"} rounded error_border`}>
                        {!uploadLoading&&<img ref={imageRef} src={studentDetails[imageid] !== "" ? `${CDN}${studentDetails[imageid]}` : "/images/photo_uploaded.svg"} alt="img" class="w-[92px] h-[92px]" />}
                    </div>
                    <div class={`absolute ${!uploadLoading?"bottom-1 right-1":'top-[41%] right-[41%]'}`}>
                        <div class="w-[18px] h-[18px] rounded-full bg-[#E6E8EA] flex justify-center items-center relative">
                            {studentDetails[imageid] === '' ? 
                                (<div className='group'>
                                    <>{uploadLoading?<UploadProgress />: <img src={ "/images/upload_pic.svg"} alt="img" class="w-3 h-3" />}</>
                                    <label for={imageid}></label>
                                    <input 
                                        id={imageid} 
                                        ref={inputRef}
                                        accept=".png,.jpg,.jpeg .gif"
                                        data-allowed-file-extensions="png,jpg,jpeg,gif" 
                                        type="file" 
                                        title="" 
                                        class="opacity-0 absolute top-0 left-0 text-[0px] w-[18px] h-[18px] cursor-pointer z-10" 
                                        onChange={(e) => handleUploadChange(e)}
                                    />
                                    <span class="absolute top-6 left-1/2 transform -translate-x-1/2 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] w-[100px] text-xs font-medium leading-[12.5px] group-hover:scale-100">Upload Image</span>

                                </div>)
                                :
                                (<button 
                                    type="button" 
                                    class="group"
                                    onClick={(e) => handleRemove(e)}
                                >
                                    <img src="/images/delete-bg-red-icon.svg" alt="icon" class="w-3 h-3" />
                                    <span class="absolute top-6 left-1/2 transform -translate-x-1/2 scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] w-[100px] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete Image</span>
                                </button>
                                )}
                        </div>
                    </div>
                </div>
                <div class="relative self-end ml-2">
                    <ImageSizeTooltip 
                        handleImageToggle={handleImageToggle}
                        imageSizeInfoHover={imageSizeInfoHover}
                        imgtransform={'scale(1.2)'}
                    />
                </div>
            </div>
        </div>
    )
}

export default ProfileImageUpload